import { useMutation } from "react-query";
import http from 'infra/http';

function useAnalisarSolicitacao() {
  return useMutation(
    async (id: string) => {
      return await http.post(`/v1/solicitacao-cadastro/${id}/analisar`, { id });
    },
  );
}

export default useAnalisarSolicitacao;
